import React from 'react';

const AgencyPerformanceCCMRMIcon: React.FC = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <rect width="32" height="32" fill="#FCC275" rx="4"></rect>
      <path
        fill="#fff"
        d="M19.08 10.01L8.18 7.16c-.12-.03-.23.05-.23.17v17.89c0 .09.08.18.18.18h6.36l4.73-7.61v-7.61a.18.18 0 00-.14-.17zm-6.2 11.89c0 .15-.12.27-.26.27h-2.25c-.15 0-.27-.12-.27-.27v-3.39c0-.15.12-.27.27-.27h2.25c.14 0 .26.12.26.27v3.39zm0-6.05c0 .15-.12.27-.26.27h-2.25c-.15 0-.27-.12-.27-.27v-3.4c0-.14.12-.26.27-.26h2.25c.14 0 .26.12.26.26v3.4zm4.2 0c0 .15-.12.27-.27.27h-2.25a.26.26 0 01-.26-.27v-3.4c0-.14.11-.26.26-.26h2.25c.15 0 .27.12.27.26v3.4z"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M13.9 25.4H6.6M17.03 25.43l3.23-5.36 2.46 1.44 2.95-5.1.05-.09"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M23.45 16.93l2.28-.61.61 2.28"
      ></path>
    </svg>
  );
};

export default AgencyPerformanceCCMRMIcon;
